import client from "./client";
import { StorageKEY } from "../models";
export const trackingApi = {
  trackerEvent: async (params = {}) => {
    const deviceToken = localStorage.getItem(StorageKEY.deviceToken) || "";
    const trackingParams = {
      ...params,
      jwt_token: deviceToken,
    };
    const configs: RequestInit = {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "access-token": deviceToken,
      },
      body: JSON.stringify(trackingParams),
    };

    await fetch(`${process.env.REACT_APP_API_TRACKER_URL}/event`, {
      ...configs,
    });
  },
  getIPAddress: async () => {
    const deviceToken = localStorage.getItem("glx-token-device") || "";

    const configs: RequestInit = {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "access-token": deviceToken,
      },
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_TRACKER_URL}/checkip`,
      {
        ...configs,
      }
    );

    const data = await response.text();

    return {
      ip: data,
    };
  },
};
